export enum Constants {
    DURATION = 1200,
    COOL_DOWN_PERIOD = 300
}